﻿import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

import { ButtonGroup } from 'react-bootstrap';

import './gmetrixButtonGroup.scss';

interface GMetrixButtonGroupProps {
    buttonObjectList: ButtonObject[];
    currentValue?: string;
    defaultIndex?: number;
}

export interface ButtonObject {
    action: () => any;
    title: string;
}

export function GMetrixButtonGroup({ buttonObjectList, currentValue, defaultIndex = 0, ...otherProps }: GMetrixButtonGroupProps) {

    const resolveIndex = () => {

        if (currentValue !== undefined) {

            const idx = buttonObjectList.findIndex(b => b.title === currentValue);
            return idx !== -1 ? idx : defaultIndex;

        }
        return defaultIndex;

    };

    const [selectedButton, setSelectedButton] = useState(resolveIndex);
    const containerRef = useRef<HTMLDivElement>(null);
    const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);
    const [sliderStyle, setSliderStyle] = useState<React.CSSProperties>({ opacity: 0 });

    useEffect(() => {

        setSelectedButton(resolveIndex());

    }, [currentValue, defaultIndex]);

    const updateSlider = useCallback(() => {

        const btn = buttonRefs.current[selectedButton];
        const container = containerRef.current;
        if (!btn || !container) return;

        const containerRect = container.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();

        setSliderStyle({
            height: btnRect.height,
            left: btnRect.left - containerRect.left,
            opacity: 1,
            width: btnRect.width
        });

    }, [selectedButton]);

    useLayoutEffect(() => {

        updateSlider();

    }, [updateSlider]);

    useEffect(() => {

        window.addEventListener('resize', updateSlider);
        return () => window.removeEventListener('resize', updateSlider);

    }, [updateSlider]);

    return (
        <ButtonGroup
            className="gmetrix-button-group rounded-pill border-light shadow-none"
            ref={containerRef}
            {...otherProps}
        >
            <div className="gmetrix-button-group__slider" style={sliderStyle} />
            {buttonObjectList.map((option, index) => (
                <button
                    onClick={() => {

                        setSelectedButton(index);
                        option.action();

                    }}
                    ref={el => {

                        buttonRefs.current[index] = el;

                    }}
                    className={`gmetrix-button-group__btn rounded-pill${selectedButton === index ? ' gmetrix-button-group__btn--active' : ''}`}
                    key={option.title}
                    type="button"
                >
                    {option.title}
                </button>
            ))}
        </ButtonGroup>
    );

}
